// extracted by mini-css-extract-plugin
export var avatar = "_qa-3";
export var avatarContainer = "_qa-2";
export var avatarSpacer = "_qa-5";
export var avatarSpacerContainer = "_qa-4";
export var avatarStackContainer = "_qa-1";
export var bubble = "_qa-0";
export var remainderBubble = "_qa-6";